import { render, staticRenderFns } from "./KeyboardInput.vue?vue&type=template&id=ba7e9078&scoped=true"
import script from "./KeyboardInput.vue?vue&type=script&lang=ts"
export * from "./KeyboardInput.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardInput.vue?vue&type=style&index=0&id=ba7e9078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7e9078",
  null
  
)

export default component.exports